import React from 'react';
import './Footer.css';

const Footer = () => {
  return (
    <div className="footer-container">
      <p>© 2025 fdbk Inc. All rights reserved.</p>
    </div>
  );
};

export default Footer;